<template>
  <Activity title="PDF" :back="{ name: 'DeliveryActivity', params: { id }}" full-size>
    <offline-indicator v-if="!delivery && !online"/>

    <font-awesome-icon icon="spinner" size="3x" spin v-else-if="loading"/>

    <report-viewer :template="template" :data="data" v-else-if="!loading && template.design"/>
  </Activity>
</template>
<script>
import ReportViewer from "@/views/reports/viewer.vue";
import Activity from "@/app/components/Activity.vue";
import {computed, watch, ref, onMounted} from "@vue/composition-api";
import OfflineIndicator from "@/app/components/OfflineIndicator.vue";

export default {
  components: {OfflineIndicator, Activity, ReportViewer},
  setup() {
    const store = window.useStore()
    const {currentRoute} = window.useRouter()

    const {id} = currentRoute.params
    const template = ref({});
    const online = computed(() => store.state.pwa.online)
    const fetchInfo = computed(() => store.state.pwa.deliveryNotes[id])
    const loading = computed(() => online.value && (typeof fetchInfo.value === 'undefined' || fetchInfo.value.loading))


    const delivery = computed(() => {
      if (loading.value) {
        return null
      }
      if (!fetchInfo.value) {
        return null
      }
      const delivery = fetchInfo.value.data
      if (!Object.keys(delivery).length) {
        return null
      }
      return delivery
    })

    watch(fetchInfo, (info) => {
      if (typeof info == 'undefined' && online.value) {
        store.dispatch('APP_FETCH_DELIVERY_NOTE', id)
      }
    }, {deep: true, immediate: true})

    watch(online, () => {
      if (online.value) {
        store.dispatch('APP_FETCH_DELIVERY_NOTE', id)
      }
    })
    const context = computed(() => delivery.value.context);

    const loadTemplate = async () => {
      const templateId = context.value === 'pigSty' ? 'PigStyDeliveryNoteReport' : 'PigletDeliveryNoteReport';
      const templateTemp = await store.dispatch('reporting/fetchById', {id: templateId});
      template.value = templateTemp;
    };
    let qualityProgramms = [];
    if (delivery.value.qualityProgramIds && delivery.value.qualityProgramIds.length > 0)
      qualityProgramms = delivery.value.qualityProgramIds.map(id => {
        const temp = store.state.pwa.deliveries.piglet.config.qualityPrograms.data.find(d => d.id === id)
        if (temp) return temp.name;

        return "";
      });

    const slaughterHouse = store.state.pwa.deliveries.piglet.config.slaughterHouse.data
      .find(d => d.id === delivery.value.slaughterHouseId);

    const transportList = store.state.pwa.deliveries.piglet.config[context.value === 'piglet' ? 'transport' : 'transportAll'].data
    const transport = transportList.find(d => d.id === delivery.value.transportId);

    const transportsForLoading= store.state.pwa.deliveries.piglet.config.transport.data;
    const transportLoading = transportsForLoading.find(d => d.id === delivery.value.loadingTransportId);
    const dischargeLoading = transportsForLoading.find(d => d.id === delivery.value.dischargeTransportId);
    const transferTransport = transportsForLoading.find(d => d.id === delivery.value.transferTransportId);

    const transporters = store.state.pwa.deliveries.piglet.config.transporter.data;
    const transporter = transporters.find(d => d.id === delivery.value.transporterId);

    const articleList = {};
      for (let article of store.state.pwa.deliveries[context.value].config.article.data) {
        articleList[article.id] = article.name;
      }
    const articles = delivery.value.articles.map(article => {
      return {
        Pieces: article.pieces,
        Category: context.value === 'piglet' ? articleList[article.articleId] ? articleList[article.articleId] : '' : article.text,
        Country: article.nativityId,
        Name: articleList[article.articleId] ? articleList[article.articleId] : '',
        Notice: article.notice,
        Lfbis: context.value === 'pigSty' ? article.lfbisOrigin : article.lfbisSty,
        Addition1: article.nativityId,
        Addition2: context.value === 'pigSty' ? article.lfbisSty : article.lfbisOrigin,
        StateId: article.stateId,
        StateIdSty: article.stateIdSty,
        Weight: article.weight
      }
    });

    const data = computed(() => ({
      'Käufer': {
        Lfbis: delivery.value ? delivery.value.deliveryFactory.lfbis : null,
        RingNr: delivery.value ? delivery.value.deliveryFactory.ringNr : null,
        Contact: delivery.value ? delivery.value.deliveryFactory.contact : null,
        Phone: delivery.value ? delivery.value.deliveryFactory.phone : null,
      },
      'Verkäufer': {
        Lfbis: delivery.value ? delivery.value.sellerFactory.lfbis : null,
        RingNr: delivery.value ? delivery.value.sellerFactory.ringNr : null,
        Contact: delivery.value ? delivery.value.sellerFactory.contact : null,
        Phone: delivery.value ? delivery.value.sellerFactory.phone : null,
        Veterinary: delivery.value ? delivery.value.sellerFactory.veterinary : null,
        VeterinaryTgd: delivery.value ? delivery.value.sellerFactory.veterinaryTGD : null,
        QualityPrograms: qualityProgramms.join(', ')
      },
      "Info": {
        SlaughterHouse: slaughterHouse ? delivery.value.slaughterHouse : delivery.value.slaughterHouse,
        Transport: transport ? transport.name : delivery.value.transport,
        TransportForLoading: transportLoading ? transportLoading.name : delivery.value.loadingTransport,
        TransportStart: delivery.value.transportStart,
        LastFeeding: delivery.value.lastFeeding,
        Cleaned: delivery.value.cleaned,
        Transporter: transporter ? transporter.licensePlate : delivery.value.transporter,
        DischargeTransport: dischargeLoading ? dischargeLoading.name : delivery.value.dischargeTransport,
        TransferTransport: transferTransport ? transferTransport.name : delivery.value.transferTransport,
        CarriageDuration: delivery.value.carriageDuration,
        BasePrice: delivery.value.basePrice,
        ReturnPigs: delivery.value.returnPigs,
        Others: delivery.value.others,
        Addition: delivery.value.addition
      },
      "Artikel": articles,
      "Unterschriften": {
        SignatureBuyer: delivery.value.signatureBuyer,
        SignatureTransporter: delivery.value.signatureTransporter,
        SignatureSeller: delivery.value.signatureSeller
      }
    }))
    onMounted(loadTemplate);

    return {
      id,
      template,
      data,
      online,
      loading,
      delivery,
    }
  }
}
</script>
